import { useTranslation } from "../i18n";
import "./PlanCards.css";

export default function PlanCards({ currentPlan, onSelectPlan, loading, loadingPlan }) {
  const { t } = useTranslation();

  const plans = [
    {
      key: "free",
      name: t("pricing.freeName"),
      price: t("pricing.freePrice"),
      period: t("pricing.freePeriod"),
      desc: t("pricing.freeDesc"),
      features: [
        t("pricing.feat1Preset"),
        t("pricing.featAiSummaries"),
        t("pricing.featAiChat"),
      ],
      excluded: [
        t("pricing.featNoChannels"),
        t("pricing.featNoWhatsapp"),
        t("pricing.featNoNotion"),
      ],
      popular: false,
    },
    {
      key: "starter",
      name: t("pricing.starterName"),
      price: t("pricing.starterPrice"),
      period: t("pricing.starterPeriod"),
      desc: t("pricing.starterDesc"),
      features: [
        t("pricing.feat4Channels"),
        t("pricing.featAiSummaries"),
        t("pricing.featAiChat"),
        t("pricing.featSchedule"),
      ],
      excluded: [
        t("pricing.featNoPresets"),
        t("pricing.featNoNotion"),
      ],
      popular: true,
    },
    {
      key: "pro",
      name: t("pricing.proName"),
      price: t("pricing.proPrice"),
      period: t("pricing.proPeriod"),
      desc: t("pricing.proDesc"),
      features: [
        t("pricing.feat6Channels"),
        t("pricing.featAllPresets"),
        t("pricing.featAiSummaries"),
        t("pricing.featAiChat"),
        t("pricing.featSchedule"),
        t("pricing.featNotion"),
      ],
      excluded: [],
      popular: false,
    },
  ];

  return (
    <div className="pc-grid">
      {plans.map((plan) => {
        const isCurrent = currentPlan === plan.key;
        const isLoading = loading && loadingPlan === plan.key;

        return (
          <div
            key={plan.key}
            className={`pc-card ${plan.popular ? "pc-card--popular" : ""}`}
          >
            {plan.popular && (
              <div className="pc-badge">{t("subscription.mostPopular")}</div>
            )}

            <div className="pc-header">
              <h3 className={`pc-name ${plan.popular ? "pc-name--accent" : ""}`}>
                {plan.name}
              </h3>
              <div className="pc-price">
                <span className="pc-price-amount">{plan.price}</span>
                <span className="pc-price-period">{plan.period}</span>
              </div>
              <p className="pc-desc">{plan.desc}</p>
            </div>

            <div className="pc-features">
              {plan.features.map((f) => (
                <div key={f} className="pc-feature">
                  <span className="pc-feature-check">{"\u2713"}</span>
                  {f}
                </div>
              ))}
              {plan.excluded.map((f) => (
                <div key={f} className="pc-feature pc-feature--excluded">
                  <span className="pc-feature-x">{"\u2014"}</span>
                  {f}
                </div>
              ))}
            </div>

            <div className="pc-cta">
              {isCurrent ? (
                <button className="pc-btn pc-btn--current" disabled>
                  {t("subscription.currentPlan")}
                </button>
              ) : (
                <button
                  className={`pc-btn ${plan.popular ? "pc-btn--primary" : "pc-btn--default"}`}
                  disabled={isLoading || loading}
                  onClick={() => onSelectPlan(plan.key)}
                >
                  {isLoading ? (
                    <span className="btn-spinner" />
                  ) : (
                    t("subscription.upgrade")
                  )}
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
